import { defineRouting } from "next-intl/routing";
import { LOCALES, DEFAULT_LOCALE } from "./locales";
import { brand } from "@/lib/brand";

// Boutique Stays is English-only (brand.singleLocale = 'en'). Restricting
// locales here means next-intl middleware treats /ar/* as not-found on that
// deployment. All other brands keep the full LOCALES array.
const activeLocales = (brand.singleLocale !== null ? [brand.singleLocale] : LOCALES) as typeof LOCALES;

export const routing = defineRouting({
  locales: activeLocales,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: "as-needed",
  localeDetection: false,
});
